export default {
  summary: 'Resumo',
  GeneralSummary: 'Dados Gerais',
  invoiceId: 'Série e número',
  format: 'Formato de origem',
  created: 'Data de criação',
  onlySupplied: 'A fatura é de apenas suplido',
  ContactsSummary: 'Dados dos interlocutores',
  provider: 'Dados do fornecedor',
  client: 'Dados do cliente',
  agent: 'Dados do gestor',
  customer: 'Dados do comprador',
  DetailsSummary: 'Detalhes da fatura',
  AmountsSummary: 'Totais',
  FileSummary: 'Arquivos anexos',
  title: 'Totais',
  totalGross: 'Base imponível total',
  totalDisc: 'Total de descontos/acréscimos globais',
  totalTaxes: 'Total de impostos',
  totalOthers: 'Total de pagamentos antecipados, despesas reembolsáveis e outros',
  total: 'TOTAL',
  concept: 'Conceito',
  RequestFactoring: 'Financiamento',
  requestFactoringTitle: 'Solicitar financiamento com:',
  selectOption: 'Selecione uma opção',
  legal: 'Aceitar as condições para solicitar financiamento',
  legalTextHeader: 'Para poder gerenciar a solicitação de financiamento, você aceita que os seguintes dados das suas faturas sejam enviados para a financeira:',
  conditions: {
    title: 'Condições para a aprovação do financiamento',
    error: 'Não são atendidas as condições para realizar o financiamento'
  },
  mandatory: 'Informação obrigatória para a entidade financeira:'
}